/* Raghu  27/10/2022 3075154998 Table Alignments and Enhancements */
/* Rohini  31/10/2022 3075154998 removed the tool bar
saikrishna 11/03/2022 3075154998 changed the paginationOptions */
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import {
  saveEnableFileFormatSystemNotes,
  ResetNotesToast as resetNotesToast,
} from '../../../../../redux/reducers/EnableFramework/AddEnableFileFormat';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';
export default function EnableSystemNotes({
  refreshNotesTable,
  setRefreshNotesTable,
  enableCode,
  fileFormatCode,
}) {
  const moment = require('moment-timezone');
  const {addEnableFileFormatSystemNotesStatus, isSystemNotesLoading} = useSelector(
    ({addEnableFileFormat}) => addEnableFileFormat,
  );
  const columns = [
    {
      title: 'Note Type',
      field: 'noteType',
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Filter Code',
      field: 'filterCode',
      render: (rowData) => <>{rowData?.code}</>,
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
  ];

  const tableRef = createRef();
  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  let transcription = '';
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  useEffect(() => {
    if (addEnableFileFormatSystemNotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        dispatch(resetNotesToast());
      }, 3000);
    }
  }, [addEnableFileFormatSystemNotesStatus]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        saveEnableFileFormatSystemNotes({
          code: fileFormatCode ? fileFormatCode : ' ',
          noteText: data,
        }),
      );
    }
  };
  return (
    <>
      <div className="custom-table global-field-table custom-toolbar-icons">
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `enableintegration/find/all/enablefileformatnotes`;
              const bodyObj = {
                code: enableCode,
                limit: rows,
                orderBy: '',
                orderDirection: '',
                search: '',
                page:
                  arrayLast && query.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!enableCode) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 5,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          options={{
            search: false,
            pageSize: rows,
            toolbar: false,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            pageSizeOptions: tablePageRows,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          actions={[
            // {
            //   icon: () => (
            //     <div>
            //       <Button variant="outlined"  onClick={() => handleSelectedNotesOption()} className="search-btn">
            //         <AddIcon /> Add
            //       </Button>
            //     </div>
            //   ),
            //   isFreeAction: true,
            //   onClick: () => handleSelectedNotesOption(),
            // },
          ]}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer ">
                <div className="mt-2">
                  <Button variant="outlined" onClick={() => handleSelectedNotesOption()} className="search-btn">
                    <AddIcon /> Add
                  </Button></div>
                <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                  <TablePagination
                    {...props}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>

            ),
          }}
        />
      </div>
      <DialogBox
        title="User Defined Notes"
        button2Text="Save"
        button1Text="Cancel"
        open={isAddaNoteDialogOpen}
        dialogClose={handleDialogClose}
        maxWidth={'md'}
      >
        {isAddaNoteDialogOpen && (
          <AddUserDefinedNotes
            transcription={transcription}
            setWebSocketOnClose={setWebSocketOnClose}
            charLimitMsg={charLimitMsg}
            setCharLimitMsg={setCharLimitMsg}
            dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            isLoading={isSystemNotesLoading}
          />
        )}
      </DialogBox>
    </>
  );
}
